let toastTimer: number | undefined;

export type ToastKind = 'warn' | 'error' | 'ok';

/** In-app toast; avoids native alert(), which blocks the event loop. */
export function toast(msg: string, kind: ToastKind = 'warn'): void {
  let t = document.getElementById('kg-toast');
  if (!t) {
    t = document.createElement('div');
    t.id = 'kg-toast';
    document.body.appendChild(t);
  }
  t.style.background = kind === 'error' ? 'var(--bad-bg)' : kind === 'ok' ? 'var(--ok-bg)' : 'var(--surf)';
  t.textContent = msg;
  requestAnimationFrame(() => {
    t!.style.opacity = '1';
    t!.style.transform = 'translateX(-50%) translateY(0)';
  });
  clearTimeout(toastTimer);
  toastTimer = window.setTimeout(() => {
    t!.style.opacity = '0';
    t!.style.transform = 'translateX(-50%) translateY(-8px)';
  }, 2600);
}

/** Banners stack in a strip under the topbar, never over it. */
function bannerHost(): HTMLElement {
  let host = document.getElementById('kg-banners');
  if (!host) {
    host = document.createElement('div');
    host.id = 'kg-banners';
    document.body.appendChild(host);
  }
  return host;
}

/** Banner id -> the text that was closed; a closed banner stays hidden only until its text changes. */
const dismissed = new Map<string, string>();

export function setBanner(id: string, text: string | null, kind: 'bad' | 'warn' = 'bad'): void {
  const existing = document.getElementById(id);
  if (!text) {
    dismissed.delete(id);
    existing?.remove();
    return;
  }
  if (dismissed.get(id) === text) return;
  dismissed.delete(id);
  const el = existing ?? document.createElement('div');
  el.id = id;
  el.className = `kg-banner ${kind}`;
  el.setAttribute('role', kind === 'bad' ? 'alert' : 'status');
  if (!existing) {
    const msg = document.createElement('span');
    msg.className = 'kg-banner-msg';
    const close = document.createElement('button');
    close.className = 'kg-banner-x';
    close.type = 'button';
    close.title = 'Dismiss';
    close.setAttribute('aria-label', 'Dismiss');
    close.textContent = '×';
    close.addEventListener('click', () => {
      dismissed.set(id, el.querySelector('.kg-banner-msg')?.textContent ?? '');
      el.remove();
    });
    el.append(msg, close);
    bannerHost().appendChild(el);
  }
  el.querySelector('.kg-banner-msg')!.textContent = text;
}

export function escHtml(s: string): string {
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
